import "./filtermenu.css";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faImage,
  faNewspaper,
  faMapMarkerAlt,
  faBriefcase
} from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";

const FilterMenu = () => {
  return (
    <div className="filter-menu">
      <div className="filter-menu-items" role="tablist" aria-label="Search categories">
        <NavLink
          className={({ isActive }) =>
            `filter-menu-item${isActive ? " item-active" : ""}`
          }
          to="/"
        >
          <FontAwesomeIcon className="icon" icon={faSearch} />
          <span> All </span>
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            `filter-menu-item fmi${isActive ? " item-active" : ""}`
          }
          to="/projects"
        >
          <FontAwesomeIcon className="icon" icon={faBriefcase} />
          <span> Projects </span>
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            `filter-menu-item fmi${isActive ? " item-active" : ""}`
          }
          to="/maps"
        >
          <FontAwesomeIcon className="icon" icon={faMapMarkerAlt} />
          <span> Maps </span>
        </NavLink>
        <NavLink
          className={({ isActive }) =>
            `filter-menu-item fmi${isActive ? " item-active" : ""}`
          }
          to="/photos"
        >
          <FontAwesomeIcon className="icon" icon={faImage} />
          <span> Photos </span>
        </NavLink>
        <a
          className="filter-menu-item fmi"
          href="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon className="icon" icon={faNewspaper} />
          <span> News </span>
        </a>
      </div>
    </div>
  );
};

export default FilterMenu;
